import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { format } from 'date-fns';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ModalService } from 'src/app/services/modal.service';
import { StudentService } from 'src/app/services/student.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { getAssessmentStudentList, getStudents } from 'src/app/store/actions/student.action';
import { AppState } from 'src/app/store/app.state';
import { getSchoolYear, getSchoolYearTerms } from 'src/app/store/selectors/school.selector';

@Component({
  selector: 'app-student-filter',
  templateUrl: './student-filter.component.html',
  styleUrls: ['./student-filter.component.scss']
})
export class StudentFilterComponent implements OnInit {
  getSchoolYear$: Observable<any>;
  schoolYear: any = [];

  getSchoolYearTerm$: Observable<any>
  schoolYearTerm: any = [];

  filteredTerms: any = [];

  selectedSchoolYear: any;
  selectedTerm: any;

  ngUnsubscribe = new Subject<void>();

  tranType!: any;

  form: FormGroup;

  showYearAndTerm: Boolean = false;

  options = [
    { label: 'Student ID Number', controlName: 'student_number' },
    { label: 'Student Name', controlName: 'name' },
    { label: 'Email', controlName: 'email' },
    { label: 'Birt Date', controlName: 'birth_date' },
    { label: 'Guardian Name', controlName: 'guardian_name' },
    { label: 'Guardian Name', controlName: 'mobile_number' },
  ];

  selectedFilters: any = [];
  
  selectedFilter: any;

  constructor(
    private studentService: StudentService,
    private modalService: ModalService,
    private fb: FormBuilder,
    private store: Store<AppState>,
  ) { 
    this.getSchoolYear$ = this.store.select(getSchoolYear);
    this.getSchoolYearTerm$ = this.store.select(getSchoolYearTerms);
  }

  ngOnInit() {
    this.form = this.fb.group({
      student_number: ['', new FormControl()],
      name: ['', new FormControl()],
      email: ['', new FormControl()],
      birth_date: ['', new FormControl()],
      guardian_name: ['', new FormControl()],
      mobile_number: ['', new FormControl()],
      has_latest_assessment: ['', new FormControl()],
      has_latest_enrollment: ['', new FormControl()],
      has_latest_preenlistment: ['', new FormControl()],
      school_year: ['', new FormControl()],
      school_year_term: ['', new FormControl()],
    });

    this.getSchoolYear$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.schoolYear = res?.data;
        this.schoolYear = this.schoolYear.sort((a, b) => b?.start_year - a?.start_year);
        // this.schoolYear = this.schoolYear.filter((e) => e?.start_year == format(new Date(), 'yyyy'));
      }
    });

    this.getSchoolYearTerm$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if(res){
        this.schoolYearTerm = res?.data;
      }
    });

    console.log(this.tranType);
  }

  filter(){
    if(this.form.valid){
      const payload = {
        filter: {
          student_number: this.form.get('student_number')?.value || null,
          name: this.form.get('name')?.value || null,
          email: this.form.get('email')?.value || null,
          birth_date: this.form.get('birth_date')?.value || null,
          guardian_name: this.form.get('guardian_name')?.value || null,
          mobile_number: this.form.get('mobile_number')?.value || null,
          has_latest_assessment: this.form.get('has_latest_assessment')?.value ? this.form.get('school_year_term')?.value : null,
          has_latest_enrollment: this.form.get('has_latest_enrollment')?.value ? this.form.get('school_year_term')?.value : null,
          has_latest_preenlistment: this.form.get('has_latest_preenlistment')?.value ? this.form.get('school_year_term')?.value : null,
        },
        include: {
          latestAssessment: this.tranType == 'assessment' ? true : false
        }
      }
  
      this.store.dispatch(setLoadingSpinner({status: true}));
      if(this.tranType == 'assessment'){
        this.store.dispatch(getAssessmentStudentList({data: payload}));
      } else{
        this.store.dispatch(getStudents({data: payload}));
      }
    }
  }

  setRequiredField(field: string) {
    this.form.addControl(field, new FormControl());
    this.form.controls[field]?.setValidators([Validators.required]);
    this.form.controls[field]?.updateValueAndValidity();
  }

  removeFieldValidation(field: any){
    this.form.get(field)?.setValidators(null);
    this.form.get(field)?.updateValueAndValidity();
  }

  cancel(){
    this.modalService.hideStudentFilter();
  }

  selectOption(option: any) {
    this.selectedFilter = option;
    this.setRequiredField(this.selectedFilter?.controlName)
    this.selectedFilters.push(this.selectedFilter);
  }

  isActiveFilter(input){
    const field = this.selectedFilters.filter((e) => e?.controlName == input)[0];
    return field ? true : false;
  }

  enableYearAndTerm(event){
    if(this.hasLatestAssessment || this.hasLatestEnrollment || this.hasLatestPreEnlistment){
      this.setRequiredField('school_year');
      this.setRequiredField('school_year_term');
    } else{
      this.removeFieldValidation('school_year');
      this.removeFieldValidation('school_year_term');
    }
  }

  applySchoolYearFilter(){
    this.filteredTerms = this.schoolYearTerm.filter((e) => e?.school_year_id == this.form.get('school_year')?.value);
  }

  get hasLatestAssessment(){
    return this.form.get('has_latest_assessment')?.value
  }

  get hasLatestEnrollment(){
    return this.form.get('has_latest_enrollment')?.value
  }

  get hasLatestPreEnlistment(){
    return this.form.get('has_latest_preenlistment')?.value
  }
}
